import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Home from "@/pages/Home";
import Dashboard from "@/pages/Dashboard";
import CosForm from "@/pages/CosForm";
import CosSearch from "@/pages/CosSearch";
import CosView from "@/pages/CosView";
import AdminUsers from "@/pages/AdminUsers";
import { getToken } from "@/lib/api";

function RequireAuth({ children }) {
  if (!getToken()) return <Navigate to="/login" replace />;
  return children;
}

function RequireAdmin({ children }) {
  if (!getToken()) return <Navigate to="/login" replace />;
  const user = JSON.parse(localStorage.getItem("cos_user") || "null");
  if (!user || user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster
          position="top-right"
          theme="dark"
          toastOptions={{
            style: { background: "#12151d", border: "1px solid rgba(255,255,255,0.08)", color: "#f1f5f9" },
          }}
        />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route
            path="/"
            element={
              <RequireAuth>
                <Home />
              </RequireAuth>
            }
          />
          <Route
            path="/cos"
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/cos/search"
            element={
              <RequireAuth>
                <CosSearch />
              </RequireAuth>
            }
          />
          <Route
            path="/cos/new"
            element={
              <RequireAuth>
                <CosForm />
              </RequireAuth>
            }
          />
          <Route
            path="/cos/:id/view"
            element={
              <RequireAuth>
                <CosView />
              </RequireAuth>
            }
          />
          <Route
            path="/cos/:id"
            element={
              <RequireAuth>
                <CosForm />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/users"
            element={
              <RequireAdmin>
                <AdminUsers />
              </RequireAdmin>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
